window.LOAD = {
    init: function () {
        $.each(window.load_after.js, function (index, url) {
            var script = document.createElement('script');
            script.src = url;
            script.defer = true;
            script.setAttribute('defer','');
            document.getElementsByTagName('body')[0].appendChild(script);
        });

        $.each(window.load_after.fonts, function (index, url) {

            var link = document.createElement('link');
            link.href = url;
            link.rel = "stylesheet";
            document.getElementsByTagName('body')[0].appendChild(link);
        });
    }
};

$(document).ready(function () {
    window.LOAD.init();
});